<template>
  <modal
    ref="modal"
    :class-name="'threaded-comments-modal'"
    :disabled="false"
    :modal-heading="modalHeading"
    :modal-open="modalOpen"
    :toggle-modal="closeModal"
  >
    <transition mode="out-in" name="modal-content">
      <div class="threaded-comments-modal__wrapper" v-if="modalOpen && parent">
        <single-comment :comment="parent" :preview="true" />

        <div class="threaded-comments-modal__comments-content">
          <threaded-comments-list :list="parent.children" :parent="parent" />

          <transition name="threaded-comments-form-slide-up">
            <threaded-comments-form
              v-show="showCommentsForm"
              :obituary-id="obituaryId"
            />
          </transition>

          <transition name="threaded-comments-form-slide-up">
            <threaded-comments-delete v-show="showDeleteContent" />
          </transition>

          <transition name="threaded-comments-form-toggle-fade">
            <threaded-comments-form-toggle v-show="!showCommentsForm" />
          </transition>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
  import Modal from "Components/Modal.vue";
  import { mapActions, mapState } from "vuex";
  import SingleComment from "../SingleComment.vue";
  import ThreadedCommentsDelete from "./Delete.vue";
  import ThreadedCommentsForm from "./Form.vue";
  import ThreadedCommentsFormToggle from "./FormToggle.vue";
  import ThreadedCommentsList from "./List.vue";

  export default {
    components: {
      Modal,

      SingleComment,
      ThreadedCommentsDelete,
      ThreadedCommentsForm,
      ThreadedCommentsFormToggle,
      ThreadedCommentsList,
    },

    computed: {
      ...mapState("threadedComments", {
        context: "modalContext",
        modalOpen: "modalIsOpen",
        parent: "parent",
      }),

      modalHeading() {
        let text = this.texts.seeComment;
        text = this.context === "create" ? this.texts.writeANewComment : text;
        text = this.context === "edit" ? this.texts.editYourComment : text;
        text = this.context === "delete" ? this.texts.deleteYourComment : text;

        return text;
      },

      showCommentsForm() {
        return (
          !this.parent.children?.length ||
          this.context === "create" ||
          this.context === "edit"
        );
      },

      showDeleteContent() {
        return this.context === "delete";
      },
    },

    data() {
      return {
        texts: lavendlaObituary.threadedComments,
      };
    },

    methods: {
      ...mapActions({
        setContext: "threadedComments/setModalContext",
        toggleModal: "threadedComments/toggleModal",
      }),

      closeModal() {
        this.toggleModal("list");
      },
    },
    name: "ThreadedCommentsModal",

    props: {
      obituaryId: {
        required: true,
        type: String,
      },
    },
  };
</script>
